import React from 'react'
import { IconName } from '../../../lib/constants'
import { Icon } from '../Icon/Icon'
import { StyledButton, StyledButtonText } from './styled'
import { StyledButtonProps } from './types'

export interface ButtonProps {
  $inverted?: boolean
  $size?: StyledButtonProps['$size']
  $variant?: 'primary' | 'secondary' | 'tertiary' | 'red' | 'green' | 'blue' | 'yellow' | 'link'
  $fullWidth?: boolean
  as?: React.ElementType | React.ReactNode | any
  title?: string
  children?: string | React.ReactNode
  disabled?: boolean
  iconLeft?: IconName | string
  iconRight?: IconName
  $ignoreTheme?: boolean
  [key: string]: any
}

export const Button = ({
  $fullWidth = false,
  $ignoreTheme,
  $inverted = false,
  $size = 'default',
  $variant = 'primary',
  as = 'button',
  title,
  children,
  disabled,
  iconLeft,
  iconRight,
  theme,
  ...rest
}: ButtonProps) => {
  const iconSize = getSize($size)

  const isExternalLink = rest.href && rest.href.startsWith('http')
  return (
    <StyledButton
      as={as}
      $size={$size}
      disabled={disabled}
      $variant={$variant}
      $inverted={$inverted}
      $fullWidth={$fullWidth}
      $isIconButton={!children && (!!iconLeft || !!iconRight)}
      $ignoreTheme={$ignoreTheme}
      {...rest}
    >
      {iconLeft && <Icon iconSize={iconSize} name={iconLeft as IconName} />}
      {isExternalLink && <Icon iconSize={iconSize} name="link-external" />}
      {title !== 'no-title' && (title ? <span className="sr-only">{title}</span> : <StyledButtonText>{children}</StyledButtonText>)}
      {iconRight && !isExternalLink && <Icon iconSize={iconSize} name={iconRight} />}
    </StyledButton>
  )
}
const getSize = ($size: string) => {
  switch ($size) {
    case 'small':
      return '0.9rem'
    case 'xsmall':
      return '0.75rem'
    case 'default':
      return '1rem'
    case 'large':
      return '1.75rem'
    default:
      return '1rem'
  }
}
